import { RefObject, useEffect } from 'react'
import KEY_VALUES from 'app/constants/key-value.constants'

interface Props {
  targetRef: RefObject<Element>
  selectors: string
  visibilityTrigger?: boolean
}

const useTabulationLoop = ({
  targetRef,
  selectors,
  visibilityTrigger = true,
}: Props) => {
  useEffect(() => {
    if (!targetRef.current || !selectors || !visibilityTrigger) return

    const focusableElements: Element[] = [
      ...targetRef.current.querySelectorAll(selectors),
    ]
    const firstFocusableElement: HTMLElement =
      focusableElements[0] as HTMLElement
    const lastFocusableElement: HTMLElement = focusableElements[
      focusableElements.length - 1
    ] as HTMLElement

    function handleKeyPress(e: KeyboardEvent) {
      const { activeElement } = document

      if (e.key !== KEY_VALUES.TAB) return

      if (!focusableElements.includes(activeElement as HTMLElement)) {
        e.preventDefault()
        firstFocusableElement.focus()
      }

      if (e.shiftKey) {
        if (activeElement === firstFocusableElement) {
          e.preventDefault()
          lastFocusableElement.focus()
        }

        return
      }

      if (activeElement === lastFocusableElement) {
        e.preventDefault()
        firstFocusableElement.focus()
      }
    }

    window.addEventListener('keydown', handleKeyPress)

    return () => {
      window.removeEventListener('keydown', handleKeyPress)
    }
  }, [selectors, visibilityTrigger, targetRef])
}

export default useTabulationLoop
